import axios from 'config/api';
import {
  ADD_ARTICLE_ERROR,
  ADD_ARTICLE_IMAGE_ERROR,
  ADD_ARTICLE_IMAGE_SUCCESS,
  ADD_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_EVENT_SUCCESS,
  FETCH_ARTICLE_ERROR,
} from 'config/constants';

export function addArticle(article) {
  return axios
    .post(`/admin/articles`, article)
    .then(response => {
      const { data, status } = response;
      console.warn('addArticle', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: ADD_ARTICLE_SUCCESS,
          article: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: ADD_ARTICLE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function addArticleImage(data, id) {
  return axios
    .post(`/admin/articles/${id}/files`, data)
    .then(response => {
      const { data, status } = response;
      console.warn('addArticleImage', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: ADD_ARTICLE_IMAGE_SUCCESS,
          article: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      console.warn('addArticleImage-error', error);
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: ADD_ARTICLE_IMAGE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}

export function addArticleEvent(id, type) {
  return axios
    .post(`/user/articles/${id}/event`, { type })
    .then(response => {
      const { data, status } = response;
      if (status === 200) {
        console.warn('status', status);
        return {
          type: UPDATE_ARTICLE_EVENT_SUCCESS,
          articles: { data, type, id },
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      console.warn('addArticleEvent-error', error);
      if (
        data &&
        (status === 400 ||
          status === 401 ||
          status === 403 ||
          status === 404 ||
          status === 422)
      ) {
        console.warn('addArticleEvent-error-data', data);
        return {
          type: FETCH_ARTICLE_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}
